import './App.css';
import React, {useEffect, useState} from 'react';
import {TextField, Button, Divider, ListItemButton, Paper, Typography, Container} from "@mui/material";
import Grid from '@mui/material/Grid';
import Champions from './Champions.js';
import Confetti from "react-confetti";
import justin from './images/justin_victory_2.png'
import VictorySpeechModal from "./VictorySpeechModal";

function AppContent() {

    const [image, setImage] = useState(null);
    const [stopConfetti, setStopConfetti] = useState(false);

    useEffect(() => {
        const img = new Image();
        img.src = justin;
        img.onload = () => setImage(img);
        img.onerror = () => console.error('Failed to load image at', img.src);
    }, []);

    const [open, setOpen] = React.useState(true);
    const [speech, setSpeech] = React.useState('two-peat but going on three-peat 💅😶‍🌫');
    const handleOpen = () => {
        setOpen(true);
        setStopConfetti(false);
    }
    const handleClose = () => {
        setOpen(false);
        setStopConfetti(true);
    };

    return (<Paper>
        {!stopConfetti && <Confetti gravity={0.05} frameRate={60}/>}
        {!stopConfetti && image && (
            <Confetti
                frameRate={60}
                gravity={0.05}
                drawShape={ctx => {
                    const scale = 0.1;
                    const x = -(image.width * scale) / 2;
                    const y = -(image.height * scale) / 2;
                    ctx.drawImage(image, x, y, image.width * scale, image.height * scale);
                }}
            />

        )}
            <VictorySpeechModal
                open={open}
                handleClose={handleClose}
                speech={speech}
            />

        <Grid container rowSpacing={2}>
            <Grid item xs={12}><h1 align={"center"}>🎉CONGRATS JUSTIN🎉</h1></Grid>

            <Grid item xs={6}><Button variant="contained" onClick={() => setStopConfetti(!stopConfetti)}>Toggle Confetti</Button></Grid>
            <Grid item xs={6}><Button variant="contained"
                                      onClick={() => {
                                          handleOpen()
                                      }}

            >Victory Speech</Button>
            </Grid>
        </Grid>
        <br/>
        <Divider/>
        <br/>
        <Champions/>
    </Paper>
)
    ;
}

export default AppContent;
